<template lang="pug">
Page.banks
    .banks__top(
        slot="header"
    )
        h1.banks__title
            | Банки

        .banks__subheader
            SvInput.banks__search(
                v-model="search"
                placeholder="Введите название банка"
                color="gray"
                size="large"
            )

            SvButton.banks__add(
                view="big"
                text="Добавить"
                :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                @click="transfer('new')"
            )

    SvTable.banks__table(
        :headers="headers"
        :body="getList"
        @transfer="(e) => transfer(e.id)"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
  name: 'Banks',

  beforeMount() {
    this.$store.dispatch('bank/getList');
  },

  data() {
    return {
      headers: [
        {
          title: 'Название',
          path: 'name',
          width: '30%',
        },
        {
          title: 'Символьный код',
          path: 'alias',
          width: '30%',
        },
        {
          title: 'Дата изменения',
          path: 'updated_at',
          width: '20%',
        },
        {
          title: 'Аквтивность',
          path: 'is_active',
          width: '20%',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      getList: 'bank/getList',
    }),

    search: {
      get() {
        return this.$store.state.bank.search;
      },

      set(search) {
        this.$store.commit('bank/setSearch', search);
      },
    },
  },

  methods: {
    transfer(id) {
      this.$router.push({
        name: 'bank-edit',
        params: {
          id,
        },
      });
    },
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTable,
  },
};
</script>

<style lang="scss" scoped>
.banks__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.banks__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.banks__search {
    width: 47%;
    min-width: 280px;
}

.banks__table {
    margin-top: 30px;
}
</style>
